import { render, staticRenderFns } from "./CabinetHeader.vue?vue&type=template&id=adea4cdc&"
import script from "./CabinetHeader.vue?vue&type=script&lang=js&"
export * from "./CabinetHeader.vue?vue&type=script&lang=js&"
import style0 from "./CabinetHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports